export default {
  name: 'IQToolMiddlePaneHeader',
  props: {
    header: {
      type: String,
      default: 'Header',
    },
    title: {
      type: String,
      default: 'Title',
    },
    additionalLabels: {
      type: Array,
      default: () => [],
    },
    showCopy: {
      type: Boolean,
      default: false,
    },
    showView: {
      type: Boolean,
      default: false,
    },
    showEdit: {
      type: Boolean,
      default: false,
    },
    goToListPage: {
      type: Function,
      default: () => {},
    },
  },
  emits: ['save', 'copy', 'view', 'edit', 'goToListPage'],
  mounted() {
  },
  methods: {
    onCopy() {
      this.$emit('copy');
    },
    onView() {
      this.$emit('view');
    },
    onEdit() {
      this.$emit('edit');
    },
    onGoToListPage() {
      this.$emit('goToListPage');
    },
  },
};
